import { useCallback } from 'react';

import {
  HINT_REQUIRED_MESSAGE,
  validateHint,
  YOUTUBE_HINT_INVALID_MESSAGE,
} from '@/views/build/form/schema/quiz/QuizHintSchema';

import { useQuizFormField } from '../../hook/useQuizFormField';

export const useCheckHintValid = () => {
  const [hint, updateHint] = useQuizFormField({
    field: 'hint',
  });

  const checkHintValid = useCallback(() => {
    if (!hint) return true;
    const { success, error } = validateHint(hint);

    if (success) {
      return true;
    }

    const isYoutubeHintError = error?.errors.some(
      error => error.message === YOUTUBE_HINT_INVALID_MESSAGE,
    );

    const isBlankError = error?.errors.some(
      error => error.message === HINT_REQUIRED_MESSAGE,
    );

    if (isYoutubeHintError && !isBlankError) {
      return true;
    }

    updateHint(undefined);

    return false;
  }, [hint, updateHint]);

  return checkHintValid;
};
